// Guide Block Types:
// - "section": { id: string, title: string, content: []}
// - "subsection": { title: string, content: [] }
// - "subdivision": { title: string, content: [] }
// - "text": { data: string | () => JSX }
// - "image": { data: string (url) }
// - "gallery": { images: [{ src, alt, credit: { name, url } }] }
// - "table": { data: [ { row: {} }]}
// - "list": { data: string (newline separated list) }
// - "component": { data: string (key to componentMap) }
// - "inlineLink": { text: string, onClick: fn }

const ecosystemData = {
  id: "ecosystem",
  title: "Ecosystem Data",
  category: "Guides",
  slug: "ecosystem",
  sections: [
    {
      id: "staking",
      title: "Pixels Staking",
      type: "section",
      content: [{
        id: "what-is-staking",
        title: "What is Staking?",
        type: "subdivision",
        content: []
      },
      {
        id: "how-to-stake",
        title: "How To Stake?",
        type: "subdivision",
        content: []
      }],
    },
    {
      id: "nucyber",
      title: "NuCyber",
      type: "section",
      content: [],
    },
    {
      id: "pixel-dungeons",
      title: "Pixel Dungeons",
      type: "section",
      content: [],
    },
    {
      id: "forgotten-runiverse",
      title: "Forgotten Runiverse",
      type: "section",
      content: [],
    },
    {
      id: "pixels-taptrack",
      title: "Pixels Tap Track",
      type: "section",
      content: [],
    },
  ],
};

export default ecosystemData;
